var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MglMap',{key:_vm.componentKey,ref:"map",attrs:{"accessToken":_vm.accessToken,"mapStyle":_vm.mapStyle,"zoom":12.8,"bearing":10,"pitch":10,"antialias":true,"center":[-73.975311, 40.751652]},on:{"load":_vm.onload}})}
var staticRenderFns = []

export { render, staticRenderFns }